import React from 'react'

const Footer = () => {
    return (
        <footer className="footer">
        <div className="container">
            <span className="text-muted fright">Copyright 2022 Treasurer</span>
        </div>
        </footer>
    )
}

export default Footer
